import { api, unwrap } from '@saas-kit/lib';

export type AnnouncementAudience = 'all' | 'specific';
export type AnnouncementChannel = 'in_app' | 'email';

export interface Announcement {
  id: string;
  subject: string;
  body: string;
  audience_kind: AnnouncementAudience;
  audience_tenant_ids: string[] | null;
  channels: AnnouncementChannel[];
  status: string;
  created_by_user_id: string;
  published_at: string | null;
  delivered_count: number;
  failed_count: number;
  metadata: Record<string, unknown>;
  created_at: string;
}

export interface AdminPage {
  total: number;
  offset: number;
  limit: number;
}

export interface AnnouncementList {
  items: Announcement[];
  page: AdminPage;
}

export interface AnnouncementDeliverySummary {
  announcement_id: string;
  total: number;
  sent: number;
  failed: number;
  pending: number;
  skipped: number;
}

export interface CreateAnnouncementPayload {
  subject: string;
  body: string;
  audience_kind: AnnouncementAudience;
  audience_tenant_ids?: string[];
  channels: AnnouncementChannel[];
}

export interface ListAnnouncementsParams {
  offset?: number;
  limit?: number;
}

export const ANNOUNCEMENT_CHANNELS: AnnouncementChannel[] = ['in_app', 'email'];

export async function listAnnouncements(
  params: ListAnnouncementsParams = {},
): Promise<AnnouncementList> {
  return unwrap<AnnouncementList>(
    api.get('/admin/announcements', {
      params: {
        offset: params.offset ?? 0,
        limit: params.limit ?? 25,
      },
    }),
  );
}

export async function getAnnouncement(id: string): Promise<Announcement> {
  return unwrap<Announcement>(api.get(`/admin/announcements/${id}`));
}

export async function getDeliverySummary(
  id: string,
): Promise<AnnouncementDeliverySummary> {
  return unwrap<AnnouncementDeliverySummary>(
    api.get(`/admin/announcements/${id}/deliveries`),
  );
}

export async function createAnnouncement(
  payload: CreateAnnouncementPayload,
): Promise<Announcement> {
  return unwrap<Announcement>(api.post('/admin/announcements', payload));
}
